import { useState, useEffect } from 'react';
import { useParams, Link } from "react-router-dom";
import questions from '../questions.json';
import { Container, Row, Col, Button, ListGroup } from 'react-bootstrap';
import '../App.css';
import categoryTest from './categoryTest';
import Nav from './nav';
import TestResult from './testResult';
import Swal from 'sweetalert2';

function Test() {
  const [questionsRandom, setquestionsRandom] = useState();
  const [numberQuestion, setnumberQuestion] = useState(0);
  const [result, setresult] = useState(false);
  const [start, setstart] = useState(0);
  const params = useParams();

  useEffect(() => {
    //יוצר מבחן רנדומאלי של 30 שאלות
    const questionsCategory = questions.filter(question => question.ranks.includes(params.category));
    const getRandom = [];
    for (let i = 1; i <= 30; i++) {
      getRandom.push(questionsCategory[Math.floor(Math.random() * questionsCategory.length)])
    }
    setquestionsRandom(getRandom)
  }, [start]);

  //פונקציה כשהמשתמש בוחר תשובה
  const answer = (numberAnswer) => {
    const UpdateAnswer = questionsRandom;
    UpdateAnswer[numberQuestion].userAnswer = numberAnswer + 1;
    setquestionsRandom(UpdateAnswer)
    if (numberQuestion < 29) {
      setnumberQuestion(numberQuestion + 1);
    }
    else {
      Swal.fire({
        title: "סיימת את המבחן", icon: 'success',
        denyButtonText: 'בדוק מבחן', showDenyButton: true, confirmButtonColor: '#f6ca3ba7',
        denyButtonColor: '#f6ca3ba7', confirmButtonText: 'עבור שוב על השאלות',
        allowEscapeKey: false,
        allowOutsideClick: false
      }).then((result) => {
        if (result.isDenied) {
          finish();
        } else if (result.isConfirmed) {
          setnumberQuestion(0);
        }
      })
    }
  }

  //כפתור בדוק מבחן
  const finish = () => {
    setresult(true);
  }

  //כפתור מבחן חדש
  const restart = () => {
    setnumberQuestion(0);
    setstart(start + 1);
    setresult(false);
  }

  //בוחר את שם הכותרת
  const name = categoryTest.filter(name => name.note == params.category);

  return (
    <div className="Test">
      {window.innerWidth >= 760 ? <Link to='/'><div className='div_home_img'>
        <img className='home_img' src='../test.png'></img></div></Link> : <div></div>}
      <Container>
        <Row>
          <Col sm={1}></Col>
          <Col xs={7} sm={6}><div className='test_name'>{name[0].category}</div></Col>
          <Col xs={5} sm={5}>
            {result === false ? <Button className='button_finish' onClick={finish}>בדוק מבחן</Button>
              : <Button className='button_finish' onClick={restart}>מבחן חדש</Button>}
          </Col>
        </Row>
      </Container>
      {result === false ? <div>
        {questionsRandom ? <div>
          <Container className='questions'>
            <Row>
              <Col sm={1}></Col>
              <Col sm={5}>
                <div className='tytle_question'>{numberQuestion + 1}. {questionsRandom[numberQuestion].question}</div>
                <ListGroup>
                  <ListGroup.Item action onClick={() => answer(0)}
                    className={questionsRandom[numberQuestion].userAnswer === 1 ? 'set_question' : 'question'}>
                    <div className='questions_text'>{questionsRandom[numberQuestion].answers[0]}</div>
                  </ListGroup.Item>
                  <ListGroup.Item action onClick={() => answer(1)}
                    className={questionsRandom[numberQuestion].userAnswer === 2 ? 'set_question' : 'question'}>
                    <div className='questions_text'>{questionsRandom[numberQuestion].answers[1]}</div>
                  </ListGroup.Item>
                  <ListGroup.Item action onClick={() => answer(2)}
                    className={questionsRandom[numberQuestion].userAnswer === 3 ? 'set_question' : 'question'}>
                    <div className='questions_text'>{questionsRandom[numberQuestion].answers[2]}</div>
                  </ListGroup.Item>
                  <ListGroup.Item action onClick={() => answer(3)}
                    className={questionsRandom[numberQuestion].userAnswer === 4 ? 'set_question' : 'question'}>
                    <div className='questions_text'>{questionsRandom[numberQuestion].answers[3]}</div>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col sm={5}>
                <div className='div_img_questions'><img className='img_questions' src={questionsRandom[numberQuestion].imageSrc}></img></div>
              </Col>
              <Col sm={1}></Col>
            </Row>
          </Container>
        </div> : <div></div>}
        <Nav numberQuestion={numberQuestion} setnumberQuestion={setnumberQuestion} />
      </div> : <div><TestResult result={questionsRandom} /></div>}
    </div>
  );
}

export default Test;